<template>
  <div>我是产品</div>
</template>

<script>
export default {
  name: 'Product'
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/pc/components/product.vue